<ul class="list-unstyled">
  <ng-content></ng-content>
</ul>
